/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { ProductNonInventoryPart } from './ProductNonInventoryPart';
import {
    ProductNonInventoryPartFromJSON,
    ProductNonInventoryPartFromJSONTyped,
    ProductNonInventoryPartToJSON,
} from './ProductNonInventoryPart';
import type { SalesUnits } from './SalesUnits';
import {
    SalesUnitsFromJSON,
    SalesUnitsFromJSONTyped,
    SalesUnitsToJSON,
} from './SalesUnits';

/**
 * The DTO representation of the appropriation in the occ layer.
 * @export
 * @interface AppropriationLine
 */
export interface AppropriationLine {
    /**
     * 
     * @type {SalesUnits}
     * @memberof AppropriationLine
     */
    salesUnit?: SalesUnits;
    /**
     * 
     * @type {ProductNonInventoryPart}
     * @memberof AppropriationLine
     */
    nonInventoryPart?: ProductNonInventoryPart;
    /**
     * 
     * @type {Product}
     * @memberof AppropriationLine
     */
    product?: Product;
    /**
     * 
     * @type {string}
     * @memberof AppropriationLine
     */
    type?: AppropriationLineTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AppropriationLine
     */
    totalQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof AppropriationLine
     */
    permittedQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof AppropriationLine
     */
    remainingQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof AppropriationLine
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof AppropriationLine
     */
    period?: AppropriationLinePeriodEnum;
    /**
     * 
     * @type {number}
     * @memberof AppropriationLine
     */
    periodFrequency?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppropriationLine
     */
    discontinued?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AppropriationLine
     */
    renewDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppropriationLine
     */
    startDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof AppropriationLine
     */
    cartQuantity?: number;
    /**
     * 
     * @type {Array<AppropriationLine>}
     * @memberof AppropriationLine
     */
    cartEntries?: Array<AppropriationLine>;
    /**
     * 
     * @type {boolean}
     * @memberof AppropriationLine
     */
    unlimited?: boolean;
    /**
     * The next period start date
     * @type {Date}
     * @memberof AppropriationLine
     */
    nextPeriodStartDate?: Date;
}


/**
 * @export
 */
export const AppropriationLineTypeEnum = {
    Product: 'PRODUCT',
    Group: 'GROUP'
} as const;
export type AppropriationLineTypeEnum = typeof AppropriationLineTypeEnum[keyof typeof AppropriationLineTypeEnum];

/**
 * @export
 */
export const AppropriationLinePeriodEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    AsNeeded: 'AS_NEEDED',
    Once: 'ONCE',
    Unknown: 'UNKNOWN'
} as const;
export type AppropriationLinePeriodEnum = typeof AppropriationLinePeriodEnum[keyof typeof AppropriationLinePeriodEnum];


/**
 * Check if a given object implements the AppropriationLine interface.
 */
export function instanceOfAppropriationLine(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppropriationLineFromJSON(json: any): AppropriationLine {
    return AppropriationLineFromJSONTyped(json, false);
}

export function AppropriationLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppropriationLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'salesUnit': !exists(json, 'salesUnit') ? undefined : SalesUnitsFromJSON(json['salesUnit']),
        'nonInventoryPart': !exists(json, 'nonInventoryPart') ? undefined : ProductNonInventoryPartFromJSON(json['nonInventoryPart']),
        'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'totalQuantity': !exists(json, 'totalQuantity') ? undefined : json['totalQuantity'],
        'permittedQuantity': !exists(json, 'permittedQuantity') ? undefined : json['permittedQuantity'],
        'remainingQuantity': !exists(json, 'remainingQuantity') ? undefined : json['remainingQuantity'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'periodFrequency': !exists(json, 'periodFrequency') ? undefined : json['periodFrequency'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'renewDate': !exists(json, 'renewDate') ? undefined : (new Date(json['renewDate'])),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'cartQuantity': !exists(json, 'cartQuantity') ? undefined : json['cartQuantity'],
        'cartEntries': !exists(json, 'cartEntries') ? undefined : ((json['cartEntries'] as Array<any>).map(AppropriationLineFromJSON)),
        'unlimited': !exists(json, 'unlimited') ? undefined : json['unlimited'],
        'nextPeriodStartDate': !exists(json, 'nextPeriodStartDate') ? undefined : (new Date(json['nextPeriodStartDate'])),
    };
}

export function AppropriationLineToJSON(value?: AppropriationLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'salesUnit': SalesUnitsToJSON(value.salesUnit),
        'nonInventoryPart': ProductNonInventoryPartToJSON(value.nonInventoryPart),
        'product': ProductToJSON(value.product),
        'type': value.type,
        'totalQuantity': value.totalQuantity,
        'permittedQuantity': value.permittedQuantity,
        'remainingQuantity': value.remainingQuantity,
        'unit': value.unit,
        'period': value.period,
        'periodFrequency': value.periodFrequency,
        'discontinued': value.discontinued,
        'renewDate': value.renewDate === undefined ? undefined : (value.renewDate.toISOString()),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'cartQuantity': value.cartQuantity,
        'cartEntries': value.cartEntries === undefined ? undefined : ((value.cartEntries as Array<any>).map(AppropriationLineToJSON)),
        'unlimited': value.unlimited,
        'nextPeriodStartDate': value.nextPeriodStartDate === undefined ? undefined : (value.nextPeriodStartDate.toISOString()),
    };
}

